import DoneIcon from '@mui/icons-material/Done'
import { Box, Step, StepLabel, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

interface BottomProgressBarStepProps {
  stepNumber: number
  stepLabel: string
  isStepActive: boolean
  isStepCompleted: boolean
  onStepChange: () => void
}

interface StyleProps {
  isCurrentStep: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  step: {
    backgroundColor: props.isCurrentStep ? theme.palette.primary.light : theme.palette.shades.shade03,
    padding: theme.spacing(1),
    borderRadius: '22px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  stepActive: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  iconContainer: {
    paddingRight: 0,
    backgroundColor: props.isCurrentStep ? theme.palette.primary.main : theme.palette.shades.shade02,
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.contrastText,
    borderRadius: '50%',
  },
  locationName: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}))

const BottomProgressBarStep: React.FC<BottomProgressBarStepProps> = ({ isStepActive, isStepCompleted, stepNumber, stepLabel, onStepChange }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isCurrentStep = isStepCompleted || isStepActive
  const { classes, cx } = useStyles({ isCurrentStep })
  return (
    <Step
      key={stepNumber}
      className={cx(classes.step, { [classes.stepActive]: isStepActive })}
      completed={isStepCompleted}
      active={isStepActive}
      onClick={onStepChange}
    >
      <StepLabel>
        <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
          <Box>
            {isStepCompleted ? (
              <DoneIcon className={classes.iconContainer} />
            ) : (
              <Typography className={classes.iconContainer}>{stepNumber}</Typography>
            )}
          </Box>
          <Box sx={{ display: !isMobile ? 'inherit' : 'none' }}>
            <Typography className={classes.locationName} variant="h5" color={isStepActive || isStepCompleted ? 'primary' : 'inherit'}>
              {stepLabel}
            </Typography>
          </Box>
        </Box>
      </StepLabel>
    </Step>
  )
}

export default BottomProgressBarStep
